import { StorageKey } from './enum';

export const localStorageService = {
    setItem: (key: StorageKey, value: string) => {
        try {
            const serializedValue = JSON.stringify(value);
            localStorage.setItem(key, serializedValue);
        } catch (error) {
            console.error('Error saving to localStorage', error);
        }
    },

    getItem: <T>(key: StorageKey): T | null => {
        try {
            const storedValue = localStorage.getItem(key);
            return storedValue ? JSON.parse(storedValue) : null;
        } catch (error) {
            console.error('Error reading from localStorage', error);
            return null;
        }
    },

    removeItem: (key: StorageKey) => {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error('Error removing from localStorage', error);
        }
    },

    clear: () => {
        try {
            localStorage.clear();
        } catch (error) {
            console.error('Error clearing localStorage', error);
        }
    },
};
